 import React from "react"





 export default function Header(props){
     <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
        <div className="container">
          <a className="navbar-brand fw-bold" href="#top">Tempo+ Produtividade</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2">
              <li className="nav-item"><a className="nav-link" href="#beneficios">Benefícios</a></li>
              <li className="nav-item"><a className="nav-link" href="#depoimentos">Depoimentos</a></li>
              <li className="nav-item"><a className="nav-link" href="#faq">Dúvidas</a></li>
            </ul>
            <a href={props.affiliateLink} onClick={props.handleCTA} className="btn btn-primary ms-lg-3">Quero Começar</a>
          </div>
        </div>
      </nav>
 }
 
 
 
 
 
